export const THEMES = {
    classic: {
  name: "Classic (Default)",
  mode: "light",
  vars: {
    // These should match your current app look closely
    "--bg": "#f5f6fa",
    "--surface": "#ffffff",
    "--surface-2": "#f1f3f8",
    "--text": "#1f2937",
    "--muted": "#6b7280",
    "--border": "rgba(31, 41, 55, 0.12)",
    "--shadow": "0 10px 30px rgba(2, 6, 23, 0.08)",
    "--primary": "#09135fff",           // typical NioTheme-ish primary
    "--primary-contrast": "#ffffff",
    "--accent": "#22c55e",
    "--danger": "#ef4444",
    "--warning": "#f59e0b",
    "--radius": "16px",
    "--chrome-bg": "#0f172a",     // header + sidebar background (dark)
"--chrome-text": "#e5e7eb",   // header + sidebar text
"--chrome-muted": "#94a3b8",  // muted text in chrome
"--chrome-border": "rgba(148, 163, 184, 0.18)", // divider lines in chrome
"--chrome-hover": "#111c33",  // hover background for menu items
"--chrome-active": "rgba(96, 165, 250, 0.18)",  // active tint (primary-ish)

  },
},

  light: {
    name: "Light",
    mode: "light",
    vars: {
      "--bg": "#f6f7fb",
      "--surface": "#ffffff",
      "--surface-2": "#f1f3f8",
      "--text": "#0f172a",
      "--muted": "#64748b",
      "--border": "rgba(15, 23, 42, 0.10)",
      "--shadow": "0 10px 30px rgba(2, 6, 23, 0.08)",
      "--primary": "#2563eb",
      "--primary-contrast": "#ffffff",
      "--accent": "#22c55e",
      "--danger": "#ef4444",
      "--warning": "#f59e0b",
      "--radius": "16px",
      "--chrome-bg": "#0f172a",     // header + sidebar background (dark)
"--chrome-text": "#e5e7eb",   // header + sidebar text
"--chrome-muted": "#94a3b8",  // muted text in chrome
"--chrome-border": "rgba(148, 163, 184, 0.18)", // divider lines in chrome
"--chrome-hover": "#111c33",  // hover background for menu items
"--chrome-active": "rgba(96, 165, 250, 0.18)",  // active tint (primary-ish)

    },
  },

  dark: {
  name: "Dark",
  mode: "dark",
  vars: {
    "--bg": "#0b1220",
    "--surface": "#0f172a",
    "--surface-2": "#111c33",
    "--text": "#e5e7eb",     // <- must be light
    "--muted": "#9aa4b2",    // <- readable muted
    "--border": "rgba(148, 163, 184, 0.18)",
    "--shadow": "0 14px 40px rgba(0, 0, 0, 0.35)",
    "--primary": "#60a5fa",
    "--primary-contrast": "#0b1220",
    "--accent": "#34d399",
    "--danger": "#fb7185",
    "--warning": "#fbbf24",
    "--radius": "16px",
    "--chrome-bg": "#0f172a",     // header + sidebar background (dark)
"--chrome-text": "#e5e7eb",   // header + sidebar text
"--chrome-muted": "#94a3b8",  // muted text in chrome
"--chrome-border": "rgba(148, 163, 184, 0.18)", // divider lines in chrome
"--chrome-hover": "#111c33",  // hover background for menu items
"--chrome-active": "rgba(96, 165, 250, 0.18)",  // active tint (primary-ish)

  },
},

  ocean: {
    name: "Ocean",
    mode: "light",
    vars: {
      "--bg": "#f4fbff",
      "--surface": "#ffffff",
      "--surface-2": "#eaf6ff",
      "--text": "#082f49",
      "--muted": "#476b84",
      "--border": "rgba(8, 47, 73, 0.12)",
      "--shadow": "0 10px 30px rgba(8, 47, 73, 0.10)",
      "--primary": "#0891b2",
      "--primary-contrast": "#ffffff",
      "--accent": "#14b8a6",
      "--danger": "#ef4444",
      "--warning": "#f59e0b",
      "--radius": "16px",
      "--chrome-bg": "#0f172a",     // header + sidebar background (dark)
"--chrome-text": "#e5e7eb",   // header + sidebar text
"--chrome-muted": "#94a3b8",  // muted text in chrome
"--chrome-border": "rgba(148, 163, 184, 0.18)", // divider lines in chrome
"--chrome-hover": "#111c33",  // hover background for menu items
"--chrome-active": "rgba(96, 165, 250, 0.18)",  // active tint (primary-ish)

    },
  },

  grape: {
    name: "Grape",
    mode: "dark",
    vars: {
      "--bg": "#0b1020",
      "--surface": "#121a33",
      "--surface-2": "#0f1730",
      "--text": "#e5e7eb",
      "--muted": "#a5b4fc",
      "--border": "rgba(165, 180, 252, 0.20)",
      "--shadow": "0 14px 40px rgba(0, 0, 0, 0.35)",
      "--primary": "#a78bfa",
      "--primary-contrast": "#0b1020",
      "--accent": "#f472b6",
      "--danger": "#fb7185",
      "--warning": "#fbbf24",
      "--radius": "16px",
      "--chrome-bg": "#0f172a",     // header + sidebar background (dark)
"--chrome-text": "#e5e7eb",   // header + sidebar text
"--chrome-muted": "#94a3b8",  // muted text in chrome
"--chrome-border": "rgba(148, 163, 184, 0.18)", // divider lines in chrome
"--chrome-hover": "#111c33",  // hover background for menu items
"--chrome-active": "rgba(96, 165, 250, 0.18)",  // active tint (primary-ish)

    },
  },
};
